export const FEATURE_TO_ENDPOINT = {
  createDigestSubscribedUserLight: "digest-createDigestSubscribedUserLight",
  thUpdateUserProperties: "tweetHunter-updateUserProperties",
  getTopicsList: "tweetListening-getTopicsList",
  getTrending: "tweetListening-getTrending",
  getTrendingTopic: "tweetListening-getTrendingTopic",
  getUniqueTweet: "tweetThreadsHunter-getUnique",
  getThreadsHunter: "tweetThreadsHunter-get",
  defaultCreators: "tweetThreadsHunter-default",
  searchCreators: "tweetThreadsHunter-search",
  tweetNow: "tweetScheduler-tweetNow",
  sendEmailGeneric: "tweetHunter-sendEmailGeneric",
  langTranslateText: "languageDetectionTranslation-translateText",
  replyNow: "tweetScheduler-reply",
  emailGateMarkVerified: "emailGate-markVerified",
  searchUsers: "twitterProxy-searchUsers",
  marketStatusChanged: "tweetMarketplace-statusChanged",
  marketAskValidation: "tweetMarketplace-askTweetValidation",
  generateTweetFromLink: "generateFromLink-generateTweetFromLink",
  getNetworkTopics: "tweetListening-getNetworkTopics",
  tweetGenerationVote: "tweetGeneration-vote",
  getTweet: "twitterFetcher-getTweet",
  saveSlug: "tweetThreadsHunter-saveSlug",
  deleteTweet: "tweetScheduler-deleteTweet",
  predictPopularity: "tweetPopularity-predict",
  likeTweet: "twitterProxy-likeTweet",
  createThumbnail: "media-createThumbnail",
  postMedia: "media-postMedia",
  getUserMedias: "media-getUserMedias",
  deleteMedia: "media-deleteMedia",
  getContacts: "tweetContacts-get",
  enrichContacts: "tweetContacts-enrich",
  verifyEmail: "tweetHunter-verifyEmail",
  sendDMs: "tweetScheduler-sendDMs",
  refreshAccount: "tweetChampions-refreshAccount",
  generateReplies: "tweetReplies-generateReplies",
  generateImageFromPost: "imageGeneration-generateImageFromPost",
  generateBearReply: "tweetReplyBear-generate",
  deleteThread: "tweetThreadsHunter-deleteThread",
  updateBlogTitle: "tweetThreadsHunter-updateBlogTitle",
  importThreadsById: "tweetThreadsHunter-importThreadsById",
  getBestGenerations: "tweetGeneration-getBestGenerations",
  mentions: "tweetChampions-mentions",
  mostRecentTweets: "tweetMostRecents-getMostRecentTweets",
  fetchTweet: "twitterFetcher-getTweet",
  searchGetTweets: "tweetChampions-getTweets",
  searchAndGenerate: "tweetButler-searchAndGenerate",
  searchAndGenerateVariations: "tweetButler-searchAndGenerateVariations",
  chatAssist: 'tweetChat-chatV3',
  generateFromList: "tweetButler-generateFromList",
  generateIdeas: "tweetThreads-generateIdeas",
  generateHooks: "tweetThreads-generateHook",
  generatePost: "tweetChampions-generatePost",
  grow: "tweetChampions-grow",
  sync: "tweetChampions-sync",
  generateNext: "tweetThreads-generateNext",
  warm: "tweetChampions-warm",
  keywords: "tweetButler-keywords",
  autocomplete: "tweetAutoComplete-autoComplete",
  generateVariations: "tweetButler-variations",
  nsfwSettingsStatus: "nsfwSettings-status",
  nsfwSettingsToggle: "nsfwSettings-toggle",
} as const;
